module.exports = __webpack_public_path__ + "media/assets/no-comment-f62a8b9e85f185d3201fb02ad4adf549.svg";